import React, { useState } from 'react'
import { Form, Input, Button, Card, Typography, App } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { authApi } from '@/services/api'

const { Title, Text } = Typography

interface LoginForm {
  username: string
  password: string
}

const LoginPage: React.FC = () => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const { setUser } = useAuthStore()
  const { message } = App.useApp()

  const from = (location.state as any)?.from?.pathname || '/dashboard'

  window.logger?.info('Login page loaded', { from, currentPath: location.pathname })

  const onFinish = async (values: LoginForm) => {
    try {
      setLoading(true)
      window.logger?.info('Login attempt started', { username: values.username })

      const response = await authApi.login(values.username, values.password)
      window.logger?.info('Login API response received', {
        success: response.success,
        hasData: !!response.data,
        message: response.message
      })

      if (response.success && response.data) {
        setUser(response.data.user, response.data.token)
        window.logger?.info('User data set in store', {
          user: response.data.user,
          hasToken: !!response.data.token
        })

        message.success('登录成功')
        window.logger?.info('Navigating to dashboard', { from, to: from })
        navigate(from, { replace: true })
      } else {
        const errorMsg = response.message || '登录失败'
        window.logger?.error('Login failed - API error', { message: errorMsg, response })
        message.error(errorMsg)
      }
    } catch (error: any) {
      const errorMsg = error.response?.data?.message || '登录失败，请检查用户名和密码'
      window.logger?.error('Login failed - Exception', {
        error: error.message,
        status: error.response?.status,
        data: error.response?.data,
        stack: error.stack
      })
      message.error(errorMsg)
    } finally {
      setLoading(false)
      window.logger?.info('Login attempt finished', { loading: false })
    }
  }

  return (
    <div className="login-container">
      <Card className="login-form">
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <Title level={2} style={{ color: '#1890ff', marginBottom: 8 }}>
            Refly 管理后台
          </Title>
          <Text type="secondary">
            代理服务器后台管理系统
          </Text>
        </div>

        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="username"
            rules={[
              { required: true, message: '请输入用户名' },
              { min: 3, message: '用户名至少3个字符' }
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="用户名"
              autoComplete="username"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: '请输入密码' },
              { min: 6, message: '密码至少6个字符' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="密码"
              autoComplete="current-password"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              style={{ height: 48 }}
            >
              登录
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: 'center', marginTop: 24 }}>
          <Text type="secondary" style={{ fontSize: 12 }}>
          </Text>
        </div>
      </Card>
    </div>
  )
}

export default LoginPage
